// app/javascript/compcalc/components/LifeExpectancy.jsx

import React from "react";
import PropTypes from "prop-types";
import { withStyles } from '@material-ui/core/styles';

import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';

import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormLabel from '@material-ui/core/FormLabel';
import MenuIcon from '@material-ui/icons/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';

import withErrorHandling from './ErrorHandling';
import { currencyFormatter } from '../utils';


const styles = theme => ({
  root: {
    flexGrow: 1,
    marginTop: theme.spacing(1),
  },
  wrapContent: {
    display: 'inline-block',
  },
  textField: {
    width: 100,
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
  },
  textFieldAmount: {
    width: 150,
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
  },
  alignCenter: {
    // background: 'green',
    display: 'flex',
    justifyContent: 'center',    // Horizontal align.
    alignItems: 'center',        // Vertical align.
  },
  alignLeft: {
    // background: 'blue',
    display: 'flex',
    flexFlow: 'row nowrap',
    alignItems: 'center',
  },
  alignRight: {
    // background: 'red',
    display: 'flex',
    flexFlow: 'row-reverse nowrap',
    alignItems: 'center',
  },
  paperStretch: {
    padding: theme.spacing(2),
  },
  paper: {
    padding: theme.spacing(2),
    display: 'inline-block',
  },
  pre: {
    width: '100%',
    maxWidth: '800px',
    whiteSpace: 'pre-wrap',
  }
});


class LifeExpectancy extends React.PureComponent {

  constructor() {
    super();

    this.itemsTable = [
      (<MenuItem dense key="2008" value="2008">2008</MenuItem>),
      (<MenuItem dense key="2010" value="2010">2010</MenuItem>),
    ];

    this.itemsAge = [];
    for (let i = 0; i < 100; ++i) {
      this.itemsAge.push(
        <MenuItem dense key={'percent' + i} value={i}>{i} - {i+1}</MenuItem>
      );
    }
    this.itemsAge.push(
      <MenuItem dense key={'percent100'} value={100}>100 or More</MenuItem>
    );

    this.state = {
      age: 50,
      table: '2010',
      expectancy: [0,0,0],
      isExpanded: false,
    };
  }

  componentDidMount = () => {
    this.fetchExp();
  }

  onTextExpand = () => {
    this.setState({ isExpanded: !this.state.isExpanded });
  }

  fetchExp = () => {
    let url = `api/v1/life-expectancy.json?age=${this.state.age}&table=${this.state.table}`
    this.props.fetch(url, results => {
      // console.log(results);
      this.setState({
        expectancy: results['expectancy'],
      });
    }).catch(e => this.props.showError(e, 'Error obtaining life expectancy from server'));
  }

  onSelectChange = (event) => {
    // console.log(event.target.name, event.target.value);
    this.setState({ [event.target.name]: event.target.value }, this.fetchExp); // Alternative componentDidUpdate().
  };

  render() {
    const { classes } = this.props;

    return (
      <Grid container spacing={1} className={classes.root} justifyContent="center">

        <Grid item xs={2} />
        <Grid item xs={4} className={classes.alignCenter}>
          {/* Age */}
          <Paper className={classes.paper}>
            <FormControl>
              <FormLabel component="legend">Age</FormLabel>
              <Select
                value={ this.state.age }
                onChange={this.onSelectChange}
                input={<Input id="age" name="age" />}
                autoWidth
              >
                { this.itemsAge }
              </Select>
            </FormControl>
          </Paper>
        </Grid>

        <Grid item xs={4} className={classes.alignCenter}>
          {/* Table */}
          <Paper className={classes.paper}>
            <FormControl>
              <FormLabel component="legend">Table</FormLabel>
              <Select
                value={ this.state.table }
                onChange={this.onSelectChange}
                input={<Input id="table" name="table" />}
                autoWidth
              >
                { this.itemsTable }
              </Select>
            </FormControl>
          </Paper>
        </Grid>
        <Grid item xs={2} />

        <Grid item xs={4} className={classes.alignCenter}>
          {/* All */}
          <Paper className={classes.paper}>
            <TextField
              id="all"
              label="All"
              letiant="outlined"
              value={ this.state.expectancy[0] }
              className={ classes.textField }
              margin="none"
              InputLabelProps={{
                shrink: true,
                className: classes.textField,
              }}
              InputProps={{
                readOnly: true,
              }}
            />
          </Paper>
        </Grid>

        <Grid item xs={4} className={classes.alignCenter}>
          {/* Male */}
          <Paper className={classes.paper}>
            <TextField
              id="male"
              label="Male"
              letiant="outlined"
              value={this.state.expectancy[1]}
              className={ classes.textField }
              margin="normal"
              InputLabelProps={{
                shrink: true,
                className: classes.textField,
              }}
              InputProps={{
                readOnly: true,
              }}
            />
          </Paper>
        </Grid>

        <Grid item xs={4} className={classes.alignCenter}>
          {/* Female */}
          <Paper className={classes.paper}>
            <TextField
              id="female"
              label="Female"
              letiant="outlined"
              value={this.state.expectancy[2]}
              className={ classes.textField }
              margin="normal"
              InputLabelProps={{
                shrink: true,
                className: classes.textField,
              }}
              InputProps={{
                readOnly: true,
              }}
            />
          </Paper>
        </Grid>

        <Grid item xs={12} className={classes.alignCenter}>
          <Paper className={classes.paper}>
            <div className={classes.pre}>
              <Typography variant="body1">
                {leText}
              </Typography>
              {this.state.isExpanded && (
                <Typography variant="body1">
                  {leText1}
                </Typography>
              )}
              <div className={classes.alignRight}>
                <Button color="primary" onClick={this.onTextExpand}>
                    {this.state.isExpanded ? 'Less ...' : 'More ...'}
                </Button>
              </div>
            </div>
          </Paper>
        </Grid>

      </Grid>
    );
  }

};

export default withStyles(styles)(withErrorHandling(LifeExpectancy));

const leText = `Life expectancy is a statistical measure of how long a person may live, based on the year of their birth, their current age and other demographic factors including gender. At a given age (age x) is the average number of years that would be lived by a group of individuals (of age x) exposed to the same mortality conditions until they die. The most commonly used measure of life expectancy is life expectancy at age zero, that is, at birth (LEB), which can be defined in two ways: while cohort LEB is the mean length of life of an actual birth cohort (all individuals born a given year) and can be computed only for cohorts that were born many decades ago, so that all their members died, period LEB is the mean length of life of a hypothetical cohort assumed to be exposed since birth until death of all their members to the mortality rates observed at a given year.`;

const leText1 = `
Mathematically, life expectancy is the expected (in the statistical sense) number of years of life remaining at a given age.

In developed countries, the number of centenarians is increasing at approximately 5.5% per year, which means doubling the centenarian population every 13 years, pushing it from some 455,000 in 2009 to 4.1 million in 2050. Japan is the country with the highest ratio of centenarians (347 for every 1 million inhabitants in September 2010). Shimane prefecture had an estimated 743 centenarians per million inhabitants.

In the United States, the number of centenarians grew from 32,194 in 1980 to 71,944 in November 2010 (232 centenarians per million inhabitants).

Available since 1945, the annual life tables are based on deaths occurring during the calendar year and on midyear postcensal population estimates provided by the U.S. Census Bureau. From 1945 to 1996, the annual life tables were abridged life tables, closed at age 85 and over, and were constructed by reference to a standard table.

Beginning with 1997 mortality data, a new methodology similar to that of the 1989–1991 decennial life tables was employed to estimate annual complete life tables to age 100, with combined life table values presented for ages 100 and over. The methodology was again revised for data years 2000–2007 using a methodology similar to that of the 1999–2001 decennial life tables. With data year 2008, the life table methodology was refined by changing the smoothing technique used to estimate the life table functions at the oldest ages.`;

